import { LogLevel } from "@azure/msal-browser";

const response = await fetch(`${process.env.PUBLIC_URL}/config.json`);
const keys = await response.json();

export const msalConfig = {
    auth: {
      clientId:keys.REACT_APP_MSAL_CLIENT_ID,
      authority:keys.REACT_APP_MSAL_AUTHORITY, 
      knownAuthorities:[`${keys.REACT_APP_KNOWN_AUTHORITY}`], 
      redirectUri: keys.REACT_APP_REDIRECT_URI,
      navigateToLoginRequestUrl:false, 
      postLogoutRedirectUri:keys.REACT_APP_REDIRECT_URI
    },
    cache: {
      cacheLocation: 'sessionStorage', 
      storeAuthStateInCookie: false, 
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }	
            }	
        }	
    }
}
